var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_4598_330_00000164482967522729908340000005650205600077121199_);}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 17,
    height: 16
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 17,
    height: 16,
    id: "mask0_4598_330_00000164482967522729908340000005650205600077121199_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.6,20c-0.4,0-0.8-0.2-1.1-0.5C4.2,19.2,4,18.8,4,18.4V5.6c0-0.4,0.2-0.8,0.5-1.1C4.8,4.2,5.2,4,5.6,4h12.8 c0.4,0,0.8,0.2,1.1,0.5C19.8,4.8,20,5.2,20,5.6v2.9h-1V5.6c0-0.2-0.1-0.3-0.2-0.4C18.7,5.1,18.6,5,18.4,5H5.6 C5.4,5,5.3,5.1,5.2,5.2C5.1,5.3,5,5.4,5,5.6v12.8c0,0.2,0.1,0.3,0.2,0.4C5.3,18.9,5.4,19,5.6,19h12.8c0.2,0,0.3-0.1,0.4-0.2 c0.1-0.1,0.2-0.3,0.2-0.4v-2.9h1v2.9c0,0.4-0.2,0.8-0.5,1.1c-0.3,0.3-0.7,0.5-1.1,0.5H5.6z M13.6,16c-0.4,0-0.8-0.2-1.1-0.5 c-0.3-0.3-0.5-0.7-0.5-1.1V9.6c0-0.4,0.2-0.8,0.5-1.1C12.8,8.2,13.2,8,13.6,8h5.8c0.4,0,0.8,0.2,1.1,0.5C20.8,8.8,21,9.2,21,9.6 v4.8c0,0.4-0.2,0.8-0.5,1.1c-0.3,0.3-0.7,0.5-1.1,0.5H13.6z M19.4,15c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4V9.6 c0-0.2-0.1-0.3-0.2-0.4C19.7,9.1,19.6,9,19.4,9h-5.8c-0.2,0-0.3,0.1-0.4,0.2C13.1,9.3,13,9.4,13,9.6v4.8c0,0.2,0.1,0.3,0.2,0.4 c0.1,0.1,0.3,0.2,0.4,0.2H19.4z M16,13.5c0.4,0,0.8-0.1,1.1-0.4s0.4-0.6,0.4-1.1s-0.1-0.8-0.4-1.1s-0.6-0.4-1.1-0.4 s-0.8,0.1-1.1,0.4s-0.4,0.6-0.4,1.1s0.1,0.8,0.4,1.1S15.6,13.5,16,13.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.8cccdd4bf48ef3a8767588a24e9275c5.svg";
export { ForwardRef as ReactComponent };